export class CutsProjectModel {
    QueryValue: string;
    CustAccount: string;
    ProjectId: string;
    ProjectName: string;
    ContactName: string;
    Address: string;
    SiteId: string;
    SiteName: string;
    Active: number;
    CreatedBy: string;
    Company: string;
    Action: string;

    constructor() {
        this.QueryValue = '';
        this.CustAccount = '';
        this.ProjectId = '';
        this.ProjectName = '';
        this.ContactName = '';
        this.Address = '';
        this.SiteId = '';
        this.SiteName = '';
        this.Active = 0;
        this.CreatedBy = '';
        this.Company = '';
        this.Action = '';

    }
  }
